import React from 'react';
import { Field, reduxForm } from 'redux-form';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';
import Validate from '../common/formValidate';
import { Row, Col } from 'react-bootstrap';

const CheckboxField = ({ input, type, description, disabled }) => (
  <label className="btn">
    <input type={type} disabled={disabled} {...input} />
    <i className="fa fa-square-o fa-2x" />
    <i className="fa fa-check-square-o fa-2x" />
    <span className="input-description"> {description}</span>
  </label>
);

const RunForm = props => {
  const { handleSubmit, progress, extended } = props;
  return (
    <div>
    <div className="page-subtitle">Customization</div>
    <form onSubmit={handleSubmit} className="mt-4">
      <Field
        name="longname"
        type="text"
        component={FormField}
        label={label.classDescriptionPh}
        description={label.classDescriptionDesc}
        validate={[Validate.Required]}
      />
      <Field
        name="primary_contact"
        type="email"
        component={FormField}
        label={label.emailAddress}
        description={label.classEmailDesc}
        validate={[Validate.Required, Validate.Email]}
      />
      {!extended && (<div>
      <Field
        name="additional_manage_schedule"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.additionalManageScheduleDesc}
      />
      <Field
        name="additional_manage_waitlist"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.additionalManageWaitlistDesc}
      />
      <Field
        name="additional_find_classes_add_drop"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.additionalFindClassesAddDropDesc}
      />
      <Field
        name="add_drop_not_open_text"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.addDropNotOpenTextDesc}
      />
        </div>
      )}
      {extended && (<div>
      <Row>
        <Col md={7} className="btn-group btn-group-vertical p-0-5" data-toggle="buttons">
          <Field
            name="allow_students_min_change"
            type="checkbox"
            normalize={value => !!value}
            component={CheckboxField}
            description={label.studentsMinChangeDesc}
          />
          <Field
            name="allow_students_max_change"
            type="checkbox"
            normalize={value => !!value}
            component={CheckboxField}
            description={label.studentsMaxChangeDesc}
          />
        </Col>
      </Row>
      <Field
        name="additional_student_text"
        label={label.additionalStudentText}
        type="text"
        component={FormField}
        description={label.additionalStudentTextDesc}
      />
      <Field
        name="additional_find_classes"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.additionalFindClassesDesc}
      />
      <Field
        name="additional_rank_classes"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.additionalRankClassesDesc}
      />
      <Field
        name="additional_view_schedules"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.additionalViewSchedulesDesc}
      />
      <Field
        name="ranking_session_not_open_text"
        label={label.Optional}
        type="text"
        component={FormField}
        description={label.rankingSessionNotOpenTextDesc}
      />
        </div>
      )}
      <button className="btn btn-block btn-primary pull-right" type="submit" disabled={progress}>
        {progress ? 'Saving...' : 'Save'}
      </button>
    </form>
    </div>
  );
};

export default reduxForm({
  form: 'RunForm'
})(RunForm);



// WEBPACK FOOTER //
// ./src/components/runs/RunForm.js